import React, { ReactNode, useMemo } from 'react'
import { AllColorsList, color, isDarkHex } from '@rst/ui-ts'
import { RenderBlockThemeProvider as CoreProvider } from '@rst/render-blocks'
import { useStore } from 'effector-react'
import { useTheme } from 'styled-components'

import { $paletteName, $theme } from '../../../model'

interface RenderBlockThemeProps {
	children?: ReactNode
}

export const RenderBlockThemeProvider = ({
	children,
}: RenderBlockThemeProps) => {
	const { inputBorderRadius, buttonShape, colors, font, borderRadius } =
		useStore($theme)

	const colorPaletteName = useStore($paletteName)

	const theme = useTheme() as { colors: AllColorsList }

	const value = useMemo(() => {
		const darkTheme = isDarkHex(
			color('gray-01')({ theme: { colors: theme?.colors } })
		)

		const result = {
			inputBorderRadius,
			borderRadius,
			buttonBorderRadius: { default: 8, round: 35, square: 0 }[buttonShape],
			colorPaletteName,
			colors,
			darkTheme,
			font,
		}

		return result
	}, [
		inputBorderRadius,
		buttonShape,
		colors,
		font,
		colorPaletteName,
		borderRadius,
		theme?.colors,
	])

	return <CoreProvider value={value}>{children}</CoreProvider>
}
